
import { Link } from 'react-router-dom';

export default function RoadmapFooter() {
  return (
    <footer className="bg-gradient-to-br from-gray-900 to-gray-800 text-white">
      <div className="max-w-7xl mx-auto px-6 py-16">
        <div className="grid md:grid-cols-3 gap-12">
          <div>
            <h3 className="text-xl font-bold mb-4">서초동 복합개발 프로젝트</h3>
            <p className="text-gray-400 text-sm leading-relaxed mb-6">
              8개 필지 통합 개발로 탄생하는 하이엔드 레지던스 오피스텔.<br />
              스마트 홈 시스템과 지속가능한 미래를 설계합니다.
            </p>
            <Link
              to="/"
              className="inline-flex items-center gap-2 text-teal-400 hover:text-teal-300 text-sm font-medium transition-colors cursor-pointer"
            >
              <i className="ri-arrow-left-line"></i>
              메인 페이지로 돌아가기
            </Link>
          </div>
          <div>
            <h4 className="text-base font-bold mb-4">로드맵 바로가기</h4>
            <ul className="space-y-2">
              {[
                { label: '통합 간트 차트', id: 'integrated-gantt' },
                { label: '핵심 마일스톤', id: 'milestones' },
                { label: '단계별 타임라인', id: 'phase-timeline' },
                { label: '현금흐름 추이', id: 'cashflow' },
                { label: '리스크 관리', id: 'risk' },
              ].map((item) => (
                <li key={item.id}>
                  <a
                    href={`#${item.id}`}
                    onClick={(e) => {
                      e.preventDefault();
                      const el = document.getElementById(item.id);
                      if (el) {
                        const offset = 20;
                        const pos = el.getBoundingClientRect().top + window.pageYOffset - offset;
                        window.scrollTo({ top: pos, behavior: 'smooth' });
                      }
                    }}
                    className="text-gray-400 hover:text-white text-sm transition-colors cursor-pointer"
                  >
                    {item.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>
          <div>
            <h4 className="text-base font-bold mb-4">문의</h4>
            <div className="space-y-3">
              <div className="flex items-center gap-3">
                <div className="w-9 h-9 bg-teal-600 rounded-lg flex items-center justify-center">
                  <i className="ri-phone-line text-sm"></i>
                </div>
                <span className="text-sm text-gray-300">02-1234-5678</span>
              </div>
              <div className="flex items-center gap-3">
                <div className="w-9 h-9 bg-teal-600 rounded-lg flex items-center justify-center">
                  <i className="ri-mail-line text-sm"></i>
                </div>
                <span className="text-sm text-gray-300">info@seocho-project.com</span>
              </div>
              <div className="flex items-center gap-3">
                <div className="w-9 h-9 bg-teal-600 rounded-lg flex items-center justify-center">
                  <i className="ri-map-pin-line text-sm"></i>
                </div>
                <span className="text-sm text-gray-300">서울 서초구 서초동 1302번지</span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="border-t border-white/10">
        <div className="max-w-7xl mx-auto px-6 py-6 flex flex-col md:flex-row justify-between items-center">
          <div className="text-gray-400 text-sm mb-3 md:mb-0">
            &copy; 2025 서초동 복합개발 프로젝트. All rights reserved.
          </div>
          <a
            href="https://readdy.ai/?ref=logo"
            target="_blank"
            rel="noopener noreferrer nofollow"
            className="text-gray-400 hover:text-white text-sm transition-colors cursor-pointer"
          >
            Powered by Readdy
          </a>
        </div>
      </div>
    </footer>
  );
}
